import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class F1120SchM2Service {

  constructor(
    private http: HttpClient
  ) {}

  saveDefaults(returnClobSettingsObj: any, defaultsChangeDetails: any[], globalService: any, GENERAL_CONFIG: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    // Build request parameters following original service pattern
    const filterParams = globalService?.globalParams?.filterParams || {};
    
    const jsonObj = JSON.stringify(defaultsChangeDetails);
    const jsonSettings = JSON.stringify(returnClobSettingsObj);

    let params = filterParams;
    params = Object.assign({}, globalService?.globalParams || {}, params);
    params = Object.assign({ jsonObj: jsonObj }, params);
    params = Object.assign({ jsonSettings: jsonSettings }, params);
    params.process_name = "component-defaults-grid-save";

    const baseUrl = GENERAL_CONFIG.base_url;
    const endpoint = `${baseUrl}/saveJsonAsPivotObject?action_code=yv5r7a`;  

    return this.http.post<any>(
      endpoint,
      params,
      { headers: headers }
    );
  }

  getDefaults(params: any, serverConfigData: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const baseUrl = serverConfigData?.base_url || '';
    const endpoint = `${baseUrl}/getDefaults`;

    return this.http.post(endpoint, params, { headers });
  }
}